import projectImg from "../Images/portfolioImg.jpg";
import Moviesearchapp from "../Images/moviesearch.png";
import Fitness from "../Images/Fitness.png";
import Goodeats from "../Images/Goodeats.png";
import Netflix from "../Images/Netflix.png";
import RandomReviews from "../Images/RandomReviews.png";
import travel from "../Images/travel.png";
import PortfilioReact from "../Images/portfolio-react.png";
import SwiggyApp from "../Images/swiggy-app.png";
import PortfolioGatsby from "../Images/portfolio-gatsby.png";

const projects = [
  {
    id: 1,
    title: "Travel Website",
    description: `Treasurie website is a responsive web design based pixel-perfect recreation of a Photoshop design built with HTML5 and CSS3.`,
    website: "https://naughty-pasteur-5291f9.netlify.app/",
    img: travel,
    category: "HTML5/CSS3",
    github: "https://github.com/chaitali72/ProjectByJuno",
    techstack: ["HTML5,CSS3,SASS"],
  },
  {
    id: 2,
    title: "SuperCook Meal App",
    description: `Random Meal generator app with React,axios,react-router-dom and The MealDB API`,
    website: "https://goodeats.vercel.app/",
    img: Goodeats,
    category: "React",
    github: "https://github.com/chaitali72/SuperCookMeal",
    techstack: ["React,React-icons,MealDB API"],
  },
  {
    id: 3,
    title: "Fitness Website",
    description: `A Responsive web design for all devices-Mobile,Tablet and Desktop - HTML,CSS,SCSS`,
    website: "https://aesthetic-boba-939568.netlify.app/",
    img: Fitness,
    category: "HTML5/CSS3",
    github: "https://github.com/chaitali72/Fitness-Space",
    techstack: ["HTML5,CSS3,SASS"],
  },
  {
    id: 4,
    title: "Portfolio V.01",
    img: projectImg,
    category: "HTML5/CSS3",
    description: `Personal portfolio to showcase my currrent work and prjects `,
    website: "https://chaitali72.github.io/",
    github: "https://github.com/chaitali72/chaitali72.github.io",
    techstack: ["HTML5,CSS3,SASS"],
  },
  {
    id: 5,
    title: "Netflix Clone",
    img: Netflix,
    category: "React",
    website: "https://netflix-clone-6a5fc.web.app/",
    description: `This project is a simplified Front-End Clone of Netflix.It uses the TMDB movieDB API to fetch movies.`,
    github: "https://github.com/chaitali72/NetflixClone-MERN",
    techstack: ["React,TMDB API,Firebase"],
  },

  {
    id: 6,
    title: "A Review Application",
    website: "https://birthdayreminder-3e992.web.app/",
    category: "React",
    description: `A review application where you can show the next button using Vanilla Javascript,Html5,css3`,
    github: "https://github.com/chaitali72/ReactProject-UseState-",
    techstack: ["React,Scss,React-icons"],
    img: RandomReviews,
  },
  {
    id: 7,
    title: "Movie search App",
    description: `Create A Movie Search Application using React Hooks And Movie db Fetch API`,
    website: "https://github.com/chaitali72/MovieSearchApp",
    img: Moviesearchapp,
    category: "React",
    github: "https://github.com/chaitali72/MovieSearchApp",
    techstack: ["React,Node.js,Express.js,MongoDB"],
  },
  {
    id: 8,
    title: "Portfolio App(v.02)",
    description: `Portfolio website using React and React Hooks`,
    website: "https://prismatic-pika-ea6e9f.netlify.app/",
    img: PortfilioReact,
    category: "React",
    github: "https://github.com/chaitali72/portfolioreact",
    techstack: ["React,React Icons,React Hooks"],
  },
  {
    id: 9,
    title: "Swiggy(Food Delivery App) ",
    description: `Swiggy-Order food online from restaurants and get it delivered.Created in React Bootcamp `,
    website: "https://aquamarine-torte-d53fdd.netlify.app/",
    img: SwiggyApp,
    category: "React",
    github: "https://github.com/chaitali72/Swiggy",
    techstack: ["React,React Hooks,Redux,Jest"],
  },
  {
    id: 10,
    title: "Portfolio App(v.03)",
    description: `Portfolio App with React + Gatsby `,
    website: "https://dev-portfolio-tawny-one.vercel.app/",
    img: PortfolioGatsby,
    category: "React",
    github: "https://github.com/chaitali72/Dev-portfolio-with-Gatsby",
    techstack: ["React,React Hooks,Redux,Jest"],
  },
];
export default projects;
